// Mock data for Vetam Remedies website

export const products = [
  // Gastrointestinal Medications
  {
    id: 'esulas-dsr',
    name: 'ESULAS-DSR',
    category: 'Gastrointestinal',
    composition: 'Esomeprazole 40mg (Enteric coated) + Domperidone 30mg (Sustained-release)',
    dosageForm: 'Capsules',
    packaging: '10x10 Capsules',
    tagline: 'The Coolest Combination In Burning Condition',
    image: '/images/Esulas-dsR.png',
    uses: [
      'GERD (Gastroesophageal Reflux Disease)',
      'Hyperacidic reflux',
      'Esophagitis healing',
      'Dyspepsia',
      'Chronic Gastritis',
      'Peptic ulcer',
      'Nausea & Vomiting'
    ],
    keyBenefits: [
      'Better esophagitis healing rate than omeprazole',
      'More effective for rapid relief',
      'Normalizes gut motility',
      'Highly efficacious & safe for long-term use',
      'Controls acidity effectively'
    ],
    
  },
  {
    id: 'ravizymes-syrup',
    name: 'Ravizymes Syrup',
    category: 'Gastrointestinal',
    composition: 'Fungal Diastase 50mg + Alpha-galactosidase 25mg + Pepsin 10mg + Lipase 10mg',
    dosageForm: 'Syrup',
    packaging: '200 ml',
    tagline: 'Digest Everything',
    image: '/images/ravizymes_wd.png',
    uses: [
      'Indigestion',
      'Functional Dyspepsia',
      'Sour Stomach',
      'Abdominal Discomfort',
      'Flatulence',
      'Heartburn'
    ],
    keyBenefits: [
      'Natural pro-digestive enzyme',
      'Promotes carbohydrate digestion',
      'Helps in protein digestion',
      'Provides high digestibility',
      'Improves defective acid secretion'
    ],
    
  },
  {
    id: 'ravizymes-drop',
    name: 'Ravizymes Drop',
    category: 'Gastrointestinal',
    composition: 'Digestive Enzyme',
    dosageForm: 'Drop',
    packaging: '15 ml',
    tagline: 'Digestive Problems Made Easy',
    image: '/images/Ravizymes drop_wd.png',
    uses: [
      'Indigestion in children',
      'Dyspepsia',
      'Abdominal Discomfort',
      'Flatulence'
    ],
    keyBenefits: [
      'Natural pro-digestive enzyme',
      'Promotes carbohydrate digestion',
      'Suitable for children'
    ],
    
  },

  // Multivitamins & Nutritional Supplements
  {
    id: 'selbus-syrup',
    name: 'SELBUS Syrup 100ml',
    category: 'Multivitamins & Nutritional',
    composition: 'Multivitamin, Multimineral & Antioxidant',
    dosageForm: 'Syrup',
    packaging: '100 ml',
    tagline: 'Live Healthy with Great Zeal & Youthfulness',
    image: '/images/Selbus 100ml-wd.png',
    uses: [
      'Chronic Fatigue Syndrome',
      'Convalescence',
      'General debility and weakness',
      'Immune Deficiency Disorder'
    ],
    keyBenefits: [
      'Builds immunity & energy',
      'Strengthens immune system',
      'Maintains proper metabolism',
      'Suitable for all age groups',
      'Protects cells from oxidative damage'
    ],
    
  },
  {
    id: 'selbus-syrup-2',
    name: 'SELBUS Syrup 225ml',
    category: 'Multivitamins & Nutritional',
    composition: 'Multivitamin, Multimineral & Antioxidant',
    dosageForm: 'Syrup',
    packaging: '225 ml',
    tagline: 'Live Healthy with Great Zeal & Youthfulness',
    image: '/images/selbus 225ml_wd.png',
    uses: [
      'Chronic Fatigue Syndrome',
      'Convalescence',
      'General debility and weakness',
      'Immune Deficiency Disorder'
    ],
    keyBenefits: [
      'Builds immunity & energy',
      'Strengthens immune system',
      'Maintains proper metabolism',
      'Suitable for all age groups',
      'Protects cells from oxidative damage'
    ],
    
  },
  {
    id: 'selbus-tablets',
    name: 'SELBUS Tablets',
    category: 'Multivitamins & Nutritional',
    composition: 'Multivitamin, Multimineral & Antioxidant',
    dosageForm: 'Tablets',
    packaging: '3x10 Tablets',
    tagline: 'Builds Immunity & Energy',
    image: '/images/selbus tab-wd.png',
    uses: [
      'Diabetes',
      'Arthritis',
      'Migraine Headache',
      'Anaemia',
      'High blood pressure',
      'Asthma',
      'Vitamin B12 deficiency',
      'Fatigue, Anxiety, Depression'
    ],
    keyBenefits: [
      'Supports Calcium & Bone Health',
      'Treats Vitamin B12 deficiency',
      'Maintains normal growth',
      'Protects cells against peroxidative damage'
    ],
    
  },
  {
    id: 'selbus-drops',
    name: 'SELBUS Drops',
    category: 'Multivitamins & Nutritional',
    composition: 'Multivitamin, Multiminerals, L-lysine, Choline & DHA',
    dosageForm: 'Drops',
    packaging: '30 ml',
    tagline: 'Healthy Brain Development',
    image: '/images/Selbus drop_wd.png',
    uses: [
      'Physical & brain development in children',
      'Healthy vision support',
      'Recovery from illness',
      'Immune system strengthening'
    ],
    keyBenefits: [
      'Improves Concentration Levels',
      'Promotes Visual Function',
      'Healthy Brain Development',
      'Improves I.Q. Level',
      '90% of brain development happens before age 5'
    ],
    
  },

  // Antibiotics
  {
    id: 'thyfi-200',
    name: 'Thyfi-200',
    category: 'Antibiotics',
    composition: 'Cefixime Dispersible Tablets IP 200mg',
    dosageForm: 'Dispersible Tablets',
    packaging: '10x10 Tablets',
    tagline: 'For Complete Destruction of Pathogens',
    image: '/images/thyfi-200_wd.png',
    uses: [
      'Enteric fever',
      'Tonsillitis',
      'Ear infection',
      'Urinary Tract infections (UTI)',
      'Acute Bronchitis',
      'Gonorrhea'
    ],
    keyBenefits: [
      'Effective in MDR typhoid',
      'Low rate of relapse',
      'High clinical cure rate of 96%',
      'Rapid eradication of pathogens',
      'Third-generation Cephalosporin'
    ],
    
  },
  {
    id: 'thyfi-of',
    name: 'Thyfi-OF',
    category: 'Antibiotics',
    composition: 'Cefixime 200mg + Ofloxacin 200mg',
    dosageForm: 'Tablets',
    packaging: '10x10 Tablets',
    tagline: 'Clear Off the Dangers of Resistance',
    image: '/images/thyfiOF 200_wd.png',
    uses: [
      'Typhoid Fever',
      'Nosocomial Infections',
      'UTI (Urinary Tract Infections)',
      'Soft Tissue Infection',
      'RTI (Respiratory Tract Infections)',
      'Surgical Prophylaxis',
      'Intra abdominal infections'
    ],
    keyBenefits: [
      '100% microbiological cure rate',
      'Fast fever control in typhoid',
      'Controls resistance through dual action',
      'Over 90-95% clinical cure rate',
      'Least chances of relapse'
    ],
    
  },
  {
    id: 'thyfi-of-100',
    name: 'Thyfi-of 100',
    category: 'Antibiotics',
    composition: 'Cefixime 100mg + Ofloxacin 100mg',
    dosageForm: 'Tablets',
    packaging: '10x10 Tablets',
    tagline: 'Clear Off the Dangers of Resistance',
    image: '/images/thyfi 100_wd.png',
    uses: [
      'Typhoid Fever',
      'Nosocomial Infections',
      'UTI',
      'Soft Tissue Infection',
      'RTI',
      'Surgical Prophylaxis'
    ],
    keyBenefits: [
      'Effective Synergism',
      'Controls resistance',
      'Fast fever control',
      'High cure rate'
    ],
    
  },
  {
    id: 'vemica-500',
    name: 'VEMICA-500',
    category: 'Antibiotics',
    composition: 'Amikacin Sulphate 500mg',
    dosageForm: 'Injection',
    packaging: '500 mg/2ml',
    tagline: 'The Real Life Saver',
    image: '/images/vemica_wd.png',
    uses: [
      'Bacteraemia',
      'Peritonitis',
      'Meningitis',
      'R.T.I./U.T.I.',
      'Septicemia',
      'Nosocomial Infections'
    ],
    keyBenefits: [
      'Most reliable for serious aerobic gram-ve infections',
      'Important for pseudomonas aeruginosa infections',
      'Can safely be combined with cephalosporins',
      'Life-saving in extensive burns'
    ],
    
  },

  // Pain Relief & Anti-inflammatory
  {
    id: 'vdeclo',
    name: 'Vdeclo',
    category: 'Pain Relief',
    composition: 'Diclofenac Sodium 75mg AQ base',
    dosageForm: 'Injection',
    packaging: '10x5x1ml',
    tagline: 'When faster pain relief matters the most',
    image: '/images/Vdeclo_wd.png',
    uses: [
      'Strains & Slip Disc',
      'Frozen shoulder',
      'Painful inflammatory conditions',
      'Rheumatoid arthritis',
      'Injury of muscles & tendons',
      'Post Trauma Osteoarthritis',
      'Pain following dental surgery'
    ],
    keyBenefits: [
      'Fast relief in stiff pain',
      'Chondro Protective Action',
      'Stimulates cartilage synthesis',
      'Relieves pain effectively'
    ],
    
  },
  {
    id: 'acvetam-p',
    name: 'ACVETAM-P',
    category: 'Pain Relief',
    composition: 'Aceclofenac 100mg + Paracetamol 325mg',
    dosageForm: 'Tablets',
    packaging: '10x10 Tablets',
    tagline: 'Trusted by Doctors. Loved by Patients.',
    image: '/images/Acvetam-p_wd.png',
    uses: [
      'Pyrexia (Fever)',
      'Spasmodic pain',
      'Inflammation & Pain',
      'Post operative inflammation',
      'Tooth extraction',
      'Fractures / Sports injuries',
      'Post partum hematomas'
    ],
    keyBenefits: [
      'Dual Power. Dual Relief. Double Safety',
      'COX-2 selective with better GI safety',
      'Long Lasting Relief',
      'Quick Action',
      'Good Efficacy'
    ],
    
  },
  {
    id: 'acvetam-sp',
    name: 'ACVETAM-SP',
    category: 'Pain Relief',
    composition: 'Aceclofenac 100mg + Paracetamol 325mg + Serratiopeptidase 15mg',
    dosageForm: 'Tablets',
    packaging: '10x10 Tablets',
    tagline: 'The safe & superior analgesic',
    image: '/images/acvetam-sp_wd.png',
    uses: [
      'Pyrexia (Fever)',
      'Spasmodic pain',
      'Inflammation & Pain',
      'Post operative inflammation',
      'Tooth extraction',
      'Fractures / Sports injuries'
    ],
    keyBenefits: [
      'Clears inflammatory exudates',
      'Resolves oedema & swelling',
      'Facilitates better NSAID penetration',
      'Improves microcirculation',
      'Hastens tissue repair'
    ],
    
  },
  {
    id: 'vensum-2500',
    name: 'Vensum-2500',
    category: 'Neurological',
    composition: 'Methylocobalamin 2500mcg + Benzyl Alcohol 2%',
    dosageForm: 'Injection',
    packaging: '1x2ml DISPO PACK',
    tagline: 'No More Neuropathic Suffering',
    image: '/images/vensum_wd2.png',
    uses: [
      'Peripheral Neuropathy',
      'Bell\'s Palsy',
      'Diabetic Neuropathy',
      'Sciatica',
      'Trigeminal Neuralgia'
    ],
    keyBenefits: [
      'Promotes myelin formation',
      'Promotes nerve cell regeneration',
      'Relieves burning sensation',
      'Vital for nervous system',
      'Increases nerve conduction'
    ],
    
  },

  // Calcium & Bone Health
  {
    id: 'calvetam',
    name: 'CALVETAM',
    category: 'Calcium & Bone Health',
    composition: 'Calcium Citrate 1000mg + Magnesium Hydroxide 100mg + Vitamin D3 200 IU + Zinc Sulphate 10mg',
    dosageForm: 'Tablets',
    packaging: '10x10 Tablets',
    tagline: 'Active Calcium for Active Life',
    image: '/images/calvetam tab_wd.png',
    uses: [
      'Osteoporosis',
      'Multiple Sclerosis',
      'Pregnancy & Lactation',
      'Postmenopausal syndrome',
      'Andropause',
      'Fractures'
    ],
    keyBenefits: [
      'Prevents bone loss',
      'Direct calcium absorption',
      'Improves bone mineralization',
      'Reduces fracture risk',
      'Controls inflammation'
    ],
    
  },
  {
    id: 'calvetam-syp',
    name: 'CALVETAM Syrup',
    category: 'Calcium & Bone Health',
    composition: 'Calcium Carbonate 625mg + Magnesium Hydroxide 180mg + Zinc Gluconate 14mg + Vitamin D3 200 IU',
    dosageForm: 'Suspension',
    packaging: '200 ml',
    tagline: 'Active Calcium for Active Life',
    image: '/images/Calvetam syp_wd.png',
    uses: [
      'Osteoporosis',
      'Multiple Sclerosis',
      'Pregnancy & Lactation',
      'Postmenopausal syndrome',
      'Andropause',
      'Fractures'
    ],
    keyBenefits: [
      'Prevents bone loss',
      'Direct calcium absorption',
      'Improves bone mineralization',
      'Reduces fracture risk',
      'Controls inflammation'
    ],
    
  },
  {
    id: 'divya-60k',
    name: 'DIVYA-60K',
    category: 'Calcium & Bone Health',
    composition: 'Cholecalciferol (Vitamin D3) 60,000 IU',
    dosageForm: 'Softgel Capsules',
    packaging: '1x4 Softgel Capsules',
    tagline: 'Add Sunshine to Life',
    image: '/images/Divya 60k_wd.png',
    uses: [
      'Weak Immune System',
      'Depression',
      'Fracture Healing',
      'Chronic Joints Pain',
      'Multiple Sclerosis',
      'Diabetes Melitus',
      'Calcium Deficiency',
      'Osteomalacia',
      'PCOS (Polycystic Ovary Syndrome)'
    ],
    keyBenefits: [
      'Fast Absorption + High Bioavailability',
      'Reduces Bone pain',
      'Increases Muscle strength',
      'Improves insulin resistance in PCOS',
      'Supports pregnancy journey'
    ],
    
  },

  // Women's Health
  {
    id: 'vita-cordial-gold',
    name: 'VITA-CORDIAL GOLD',
    category: 'Women\'s Health',
    composition: 'Uterine Tonic',
    dosageForm: 'Tonic',
    packaging: '450 ml',
    tagline: 'A Complete Uterine Tonic for Health & Beauty',
    image: '/images/Vita-codial gold_wd.png',
    uses: [
      'Menorrhagia',
      'Irregular Cycles',
      'Unexplained Infertility',
      'Dysmenorrhoea',
      'Menopausal Syndrome'
    ],
    keyBenefits: [
      'Relaxes Uterine smooth muscles',
      'Relieves menstrual cramps & pain',
      'Restores mental peace',
      'Prevents recurrence of painful episodes',
      'Regulates Feminine Rhythm'
    ],
    
  },
  {
    id: 'z-fm-xt-tablets',
    name: 'Z-FM XT Tablets',
    category: 'Women\'s Health',
    composition: 'Ferrous Ascorbate 100mg + Folic Acid 1.5mg + Zinc Sulphate 22.5mg',
    dosageForm: 'Tablets',
    packaging: '10x10 Tablets',
    tagline: 'An advance iron care',
    image: '/images/zfm-xt tab_wd.png',
    uses: [
      'Iron deficiency',
      'Lactation',
      'Blood loss',
      'Anaemia',
      'Menorrhagia',
      'Pregnancy'
    ],
    keyBenefits: [
      'Gold standard in iron therapy',
      'Prevention & treatment of iron deficiency',
      'Vital for foetal growth',
      'Produces normoblastic marrow'
    ],
    
  },
  {
    id: 'z-fm-xt-suspension',
    name: 'Z-FM XT Suspension',
    category: 'Women\'s Health',
    composition: 'Ferrous Ascorbate 30mg + Folic Acid 550mg',
    dosageForm: 'Suspension',
    packaging: '200 ml',
    tagline: 'Complete Care for both Mother & Baby',
    image: '/images/zfm-xt syp -wd.png',
    uses: [
      'Lactation',
      'Convalescence',
      'Menorrhagia',
      'Anaemia',
      'Blood Loss',
      'Pregnancy'
    ],
    keyBenefits: [
      'Higher success rate in anemia (93.33%)',
      'Faster rise in haemoglobin',
      'Complete care for mother and baby',
      'Helps in formation of blood cells'
    ],
    
  }
];

export const categories = [
  {
    id: 'gastrointestinal',
    name: 'Gastrointestinal',
    description: 'Advanced solutions for digestive health and acid-related disorders',
    icon: 'Activity',
    image: '/images/Gastrointestinal.png',
    count: products.filter(p => p.category === 'Gastrointestinal').length
  },
  {
    id: 'Multivitamins',
    name: 'Multivitamins & Nutritional',
    description: 'Complete nutritional support for all age groups',
    icon: 'Zap',
    image: '/images/Multivitamins & Nutritional.png',
    count: products.filter(p => p.category === 'Multivitamins & Nutritional').length
  },
  {
    id: 'antibiotics',
    name: 'Antibiotics',
    description: 'Effective antimicrobial therapy for bacterial infections',
    icon: 'Shield',
    image: '/images/Antibiotics.png',
    count: products.filter(p => p.category === 'Antibiotics').length
  },
  {
    id: 'pain-relief',
    name: 'Pain Relief',
    description: 'Fast and effective pain management solutions',
    icon: 'Heart',
    image: '/images/Pain Relief.png',
    count: products.filter(p => p.category === 'Pain Relief').length
  },
  {
    id: 'neurological',
    name: 'Neurological',
    description: 'No More Neurological Suffering',
    icon: 'Heart',
    image: '/images/Neurological.png',
    count: products.filter(p => p.category === 'Neurological').length
  },
  {
    id: 'bone-health',
    name: 'Calcium & Bone Health',
    description: 'Comprehensive Calcium & Bone Health and calcium supplementation',
    icon: 'Bone',
    image: '/images/Calcium & Bone Health.png',
    count: products.filter(p => p.category === 'Calcium & Bone Health').length
  },
  {
    id: 'womens-health',
    name: 'Women\'s Health',
    description: 'Specialized care for women\'s health needs',
    icon: 'Users',
    image: '/images/Women\'s Health.png',
    count: products.filter(p => p.category === 'Women\'s Health').length
  },
];

export const stockists = [
  {
    id: 1,
    name: 'Balajee Enterprises',
    city: 'Jhumri Telaiya',
    state: 'Jharkhand',
    address: 'Gouri Sankar Mandir Road, Jhumri Telaiya-825409',
    phone: '+91 7654515339',
    email: 'Balajee.koderma@gmail.com',
    operatingHours: '10 : 00 AM - 9 : 00 PM',
    established: '',
    image: 'https://images.unsplash.com/photo-1638202993928-7267aad84c31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxkb2N0b3JzfGVufDB8fHxibHVlfDE3NzA4ODIxNDB8MA&ixlib=rb-4.1.0&q=85',
  },
  {
    id: 2,
    name: 'Siddhi Pharma',
    city: 'Hazaribagh',
    state: 'Jharkhand',
    address: 'Gali No.3 Nawabganj, Hazaribagh- 825303',
    phone: '+91 9431531298',
    email: 'sanjaykragarwal12@gmail.com',
    operatingHours: '10 : 00 - 9 : 00 PM',
    established: '',
    image: 'https://images.unsplash.com/photo-1655313719493-16ebe4906441?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxkb2N0b3JzfGVufDB8fHxibHVlfDE3NzA4ODIxNDB8MA&ixlib=rb-4.1.0&q=85',

  }
];

export const companyInfo = {
  name: 'Vetam Remedies Private Limited',
  tagline: 'Trusted by Doctors. Loved by Patients.',
  associatedWith: 'WALTER®',
  corporateOffice: {
    address: 'Plot No - 174, Phase-IX Industrial Area, Mohali, Punjab (IN) - 160062',
    phone: '+91 9031799099',
    email: 'vetamremedies928@gmail.com'
  },
  certifications: ['WHO-GMP CERTIFIED', 'GLP & ISO Certified Plants'],
  values: [
    'Efficacy, Safety & Quality',
    'Building Trust',
    'Offer Quality Medicine for Better Health',
    'National and International Accreditations'
  ],
  manufacturing: 'Manufactured under strategic partnership with WHO GMP manufacturing plants',
  mission: 'To provide quality medicines at the lowest market prices, making healthcare accessible to all.',
  vision: 'To become a trusted pharmaceutical partner for healthcare professionals and patients across India.'
};
/*
export const testimonials = [
  {
    id: 1,
    name: 'Dr. Rajesh Kumar',
    designation: 'MD, General Physician',
    location: 'Ranchi',
    image: 'https://images.unsplash.com/photo-1638202993928-7267aad84c31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxkb2N0b3JzfGVufDB8fHxibHVlfDE3NzA4ODIxNDB8MA&ixlib=rb-4.1.0&q=85',
    testimonial: 'Vetam Remedies has consistently delivered quality medicines at competitive prices. Their range of products covers most therapeutic areas, making it my go-to choice for prescriptions.',
    rating: 5
  },
  {
    id: 2,
    name: 'Dr. Priya Sharma',
    designation: 'MBBS, DGO',
    location: 'Jamshedpur',
    image: 'https://images.unsplash.com/photo-1655913197692-012897652d13?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxkb2N0b3JzfGVufDB8fHxibHVlfDE3NzA4ODIxNDB8MA&ixlib=rb-4.1.0&q=85',
    testimonial: 'The quality of Vetam products, especially in women\'s health segment, is exceptional. WHO-GMP certification gives me confidence in recommending these medicines to my patients.',
    rating: 5
  },
  {
    id: 3,
    name: 'Mr. Suresh Patel',
    designation: 'Retail Pharmacist',
    location: 'Ranchi',
    image: 'https://images.unsplash.com/photo-1655313719493-16ebe4906441?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxkb2N0b3JzfGVufDB8fHxibHVlfDE3NzA4ODIxNDB8MA&ixlib=rb-4.1.0&q=85',
    testimonial: 'As a retailer, Vetam Remedies provides excellent margins and their products are highly demanded by customers. The company support is outstanding.',
    rating: 5
  }
];
*/